import { t } from 'i18next';
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import Image404 from '~assets/404.svg';
import { Button } from '~components/index';
import { ROUTES } from '~routes/routesDictionary';
import './Error404.scss';

const Error404 = ({ fullscreen }: Error404Props) => {
  const navigate = useNavigate();

  return (
    <div className={`errorPage ${fullscreen ? 'fullscreen' : 'windowed'}`}>
      <div className="mb-3">
        <Image src={Image404} alt="img_Error" width="80%" fluid />
      </div>
      <h1 className="fw-bold">{t('components.error404.title')}</h1>
      <p className="mb-4">{t('components.error404.description')}</p>
      <Button
        variant={fullscreen ? 'primary' : 'secondary'}
        border="none"
        onClick={() => navigate(fullscreen ? ROUTES.ROOT : ROUTES.PLATFORM)}
        text="btns.return"
      />
    </div>
  );
};

export default Error404;
